// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2_91P","alert":"SettungsInbox_alert__32Ug8"};